var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyWishlist(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 118,
    height: 118,
    viewBox: "0 0 118 118",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6032",
    "data-name": "Group 6032",
    transform: "translate(-1041 -304)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_321",
    "data-name": "Ellipse 321",
    cx: 59,
    cy: 59,
    r: 59,
    transform: "translate(1041 304)",
    fill: "#f1f6ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(1078.349 339.226)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7157",
    "data-name": "Path 7157",
    d: "M32.235,39.882H10.07a7.417,7.417,0,0,1-7.362-8.341l2.474-19.79a7.429,7.429,0,0,1,7.358-6.5H29.757a7.429,7.429,0,0,1,7.362,6.5l2.474,19.79a7.417,7.417,0,0,1-7.358,8.341ZM12.536,8.218a4.459,4.459,0,0,0-4.413,3.9L5.649,31.909a4.451,4.451,0,0,0,4.421,5H32.235a4.451,4.451,0,0,0,4.417-5l-2.474-19.79a4.459,4.459,0,0,0-4.413-3.9Z",
    transform: "translate(0 3.916)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7158",
    "data-name": "Path 7158",
    d: "M24.566,12.134H8.734A1.484,1.484,0,0,1,7.25,10.65V8.671A7.431,7.431,0,0,1,14.671,1.25h3.958A7.431,7.431,0,0,1,26.05,8.671V10.65A1.484,1.484,0,0,1,24.566,12.134ZM10.218,9.166H23.082V8.671a4.459,4.459,0,0,0-4.453-4.453H14.671a4.459,4.459,0,0,0-4.453,4.453Z",
    transform: "translate(4.503)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7159",
    "data-name": "Path 7159",
    d: "M17.521,28.045c-.948,0-5.872-.368-9.913-7.631a7.378,7.378,0,0,1,.893-9.3,6.072,6.072,0,0,1,5.385-1.662A6.307,6.307,0,0,1,17.5,11.616,6.178,6.178,0,0,1,20.862,9.4a5.984,5.984,0,0,1,5.175,1.274,7.308,7.308,0,0,1,1.385,9.741C23.391,27.677,18.469,28.045,17.521,28.045Zm-4.75-15.733a3.166,3.166,0,0,0-2.2.92,4.571,4.571,0,0,0-.374,5.739c2.689,4.819,5.872,6.105,7.324,6.105s4.635-1.286,7.322-6.107a4.532,4.532,0,0,0-.661-5.99,3.044,3.044,0,0,0-2.608-.695,4.354,4.354,0,0,0-2.687,2.761,1.546,1.546,0,0,1-2.715,0,4.136,4.136,0,0,0-2.836-2.68,3.028,3.028,0,0,0-.564-.053Z",
    transform: "translate(3.632 7.837)",
    fill: "#0a64f9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyWishlist);
export default __webpack_public_path__ + "static/media/emptyWishlist.8cc685b7f5c28e5103b9c0c2c966306f.svg";
export { ForwardRef as ReactComponent };